import get from 'lodash/get';
import head from 'lodash/head';

import { PinDeliverEmbeddedError } from '../types/PinDeliverEmbeddedError';

/**
 * Extracts an error code from a failed pin delivery response, if one was
 * provided by the backend.
 *
 * Error codes (e.g., 21211, 30006, 30008) allow the UI to render a
 * more specific error message describing why the pin could not be delivered.
 *
 * @param error - The error object returned from a failed API request.
 * @returns The error code, or undefined when one is not present.
 */
export const extractPinDeliverErrorCode = (
  error: unknown,
): string | undefined => {
  const errors: PinDeliverEmbeddedError[] = get(
    error,
    'response.data._embedded.errors',
    [],
  );

  const firstError = head(errors);

  return firstError?.errorCode;
};
